export default "__VITE_ASSET__orKx8EQV__"